import { render, staticRenderFns } from "./FirmsVehicle.vue?vue&type=template&id=33b20326&scoped=true"
import script from "./FirmsVehicle.vue?vue&type=script&lang=ts"
export * from "./FirmsVehicle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b20326",
  null
  
)

export default component.exports